// ---------- inviter à installer l'application ----------
// Le jeu se joue aussi dans un navigateur, et c'est par là que beaucoup le découvrent (un lien
// partagé, une publicité). Mais c'est l'APPLICATION qui fait revenir : une icône sur l'écran
// d'accueil, le plein écran, le hors-ligne. Et c'est elle qui porte la publicité dont le jeu vit.
//
// Trois règles, pour inviter sans lasser :
//  - jamais avant d'avoir gagné : la première partie est faite pour donner envie, pas pour
//    demander quelque chose ;
//  - seulement là où l'application existe — un navigateur sur Android — et jamais dans
//    l'application elle-même ;
//  - fermée, l'invitation se tait une semaine.
// L'argument qui lève la dernière hésitation est la progression : elle SUIT le joueur, par son
// code de reprise (Réglages → Retrouver ma progression). On ne perd rien à changer.

import { t } from './i18n';
import { isNative } from './platform';
import { esc } from './ui';

export const PLAY_URL = 'https://play.google.com/store/apps/details?id=fr.tidou44.verbigrid';

const KEY = 'verbigrid:install:v1';
const QUIET_MS = 7 * 86_400_000;

function dismissedAt(): number {
  try {
    return Number(localStorage.getItem(KEY)) || 0;
  } catch {
    return 0;
  }
}

/** Faut-il inviter ? Un navigateur Android, et pas d'invitation fermée depuis moins d'une semaine. */
export function shouldInvite(): boolean {
  if (isNative() || !/Android/i.test(navigator.userAgent)) return false;
  // L'application web déjà installée sur l'écran d'accueil (PWA) : elle a l'icône et le plein
  // écran, l'invitation n'y a plus qu'un argument sur trois.
  if (matchMedia('(display-mode: standalone), (display-mode: fullscreen)').matches) return false;
  return Date.now() - dismissedAt() > QUIET_MS;
}

export function dismissInvite(): void {
  try {
    localStorage.setItem(KEY, String(Date.now()));
  } catch {
    /* stockage refusé : l'invitation reviendra au prochain lancement */
  }
}

/** Le bandeau du chemin : une ligne, un bouton, une croix. */
export const inviteBanner = (): string =>
  `<div class="invite" role="complementary">
    <span class="invite-txt"><b>${esc(t('install.title'))}</b><small>${esc(t('install.short'))}</small></span>
    <a class="btn btn-go invite-go" href="${PLAY_URL}" target="_blank" rel="noopener" data-act="install">${esc(t('install.cta'))}</a>
    <button class="invite-x" type="button" data-act="invite-close" aria-label="${esc(t('install.close'))}">×</button>
  </div>`;

/** La carte de fin de partie : le moment où l'on a envie de continuer. */
export const inviteCard = (): string =>
  `<div class="invite-card">
    <b>${esc(t('install.cardTitle'))}</b>
    <ul>
      <li>${esc(t('install.why1'))}</li>
      <li>${esc(t('install.why2'))}</li>
      <li>${esc(t('install.why3'))}</li>
    </ul>
    <a class="btn btn-go" href="${PLAY_URL}" target="_blank" rel="noopener" data-act="install">${esc(t('install.cta'))}</a>
  </div>`;
